module.exports = __webpack_public_path__ + "img/G - 01.ffabcbd4.png";